/* TENSO — PDP lightbox zoom upgrade (2 Aug). Loaded after tenso-pdp.js; replaces its
   desktop-only, no-zoom lightbox wiring by rebinding the frames. All viewports.
   Click/tap toggles 2.4x at point · wheel 1–4x · drag pans · two-pointer pinch. */
(function(){
  "use strict";
  function init(){
    var root=document.querySelector('[data-pdpx]');
    if(!root) return;
    var lb=root.querySelector('[data-lightbox]');
    if(!lb) return;
    var lbImg=lb.querySelector('img');
    var frames=[].slice.call(root.querySelectorAll('[data-frame]'));
    // detach tenso-pdp.js's own frame click handlers by cloning frames' listeners? No —
    // its handlers only exist on >=1024px. We rebind by capturing first and stopping propagation.
    var scale=1,tx=0,ty=0,drag=null,pinch=null,pts={};
    function apply(){lbImg.style.transform='translate('+tx+'px,'+ty+'px) scale('+scale+')';
      lbImg.style.cursor=scale>1?'grab':'zoom-in';}
    function reset(){scale=1;tx=0;ty=0;apply();}
    function clampPan(){
      var r=lb.getBoundingClientRect(), iw=lbImg.clientWidth*scale, ih=lbImg.clientHeight*scale;
      var mx=Math.max(0,(iw-r.width)/2+40), my=Math.max(0,(ih-r.height)/2+40);
      tx=Math.max(-mx,Math.min(mx,tx)); ty=Math.max(-my,Math.min(my,ty));
    }
    function zoomAt(cx,cy,ns){
      ns=Math.max(1,Math.min(4,ns));
      var r=lbImg.getBoundingClientRect();
      var ox=cx-(r.left+r.width/2), oy=cy-(r.top+r.height/2);
      tx-=ox*(ns/scale-1); ty-=oy*(ns/scale-1);
      scale=ns; if(scale===1){tx=0;ty=0;} clampPan(); apply();
    }
    frames.forEach(function(f){
      f.addEventListener('click',function(e){
        e.stopImmediatePropagation();
        var img=f.querySelector('img');if(!img)return;
        lbImg.src=img.getAttribute('data-full')||img.src;
        lbImg.alt=img.alt||''; reset();
        if(lb.showModal&&!lb.open)lb.showModal();
      },true);
    });
    lbImg.addEventListener('click',function(e){
      if(drag&&drag.moved)return;
      zoomAt(e.clientX,e.clientY,scale>1?1:2.4);
    });
    lb.addEventListener('wheel',function(e){e.preventDefault();
      zoomAt(e.clientX,e.clientY,scale*(e.deltaY<0?1.2:1/1.2));},{passive:false});
    lbImg.addEventListener('pointerdown',function(e){
      pts[e.pointerId]=e; lbImg.setPointerCapture(e.pointerId);
      var k=Object.keys(pts);
      if(k.length===1&&scale>1){drag={x:e.clientX,y:e.clientY,tx:tx,ty:ty,moved:false};}
      if(k.length===2){var a=pts[k[0]],b=pts[k[1]];
        pinch={d:Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY),s:scale,
               cx:(a.clientX+b.clientX)/2, cy:(a.clientY+b.clientY)/2}; drag=null;}
    });
    lbImg.addEventListener('pointermove',function(e){
      if(!pts[e.pointerId])return; pts[e.pointerId]=e;
      var k=Object.keys(pts);
      if(pinch&&k.length===2){var a=pts[k[0]],b=pts[k[1]];
        var d=Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY);
        zoomAt(pinch.cx,pinch.cy,pinch.s*d/pinch.d);}
      else if(drag){var dx=e.clientX-drag.x,dy=e.clientY-drag.y;
        if(Math.abs(dx)+Math.abs(dy)>4)drag.moved=true;
        tx=drag.tx+dx;ty=drag.ty+dy;clampPan();apply();}
    });
    function up(e){delete pts[e.pointerId];
      if(Object.keys(pts).length<2)pinch=null;
      if(drag&&!Object.keys(pts).length){setTimeout(function(){drag=null;},0);}}
    lbImg.addEventListener('pointerup',up);lbImg.addEventListener('pointercancel',up);
    lb.addEventListener('close',reset);
  }
  if(document.readyState!=='loading')init();
  else document.addEventListener('DOMContentLoaded',init);
})();
